define('views/components/country_distributor/country_distributor',['require','backbone','text!templates/components/country_distributor/country_distributor.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/country_distributor/country_distributor.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distributor-item'
    });
});
